import React, { useState } from 'react';
import getTableOptions from '../constants/TableOptions';
import DialogTable from './DialogTable';
import { dependentBenefitCols } from '../constants/EmployeeCols';
import ReactTable from '../components/ReactTable';
import { useDependentCols } from '../hooks/EmployeeCols';

export default function Dependents(props) {
  const [state, setState] = useState({
    open: false,
    dependent: null,
    title: '',
  });

  const dependentCols = useDependentCols();

  const handleClose = () => {
    setState({ ...state, open: false, dependent: null, title: '' });
  };
  if (!props.data) return null;

  const options = getTableOptions({
    cols: dependentCols,
    fileName: props.fileName,
  });

    /**
     * Checks if the user has unmasked access permissions
     * @param {Object} props - Component props containing user credentials
     * @returns {boolean} - Returns true if user has a role containing 'unmasked',
     *                     false otherwise
     */
    const checkIsUnmasked = (props) => {
        const roleActions = props?.fetchInitialData?.credentials?.user?.roleActions || [];
        return roleActions.some(action => action.role.toLowerCase().includes('unmasked'));
    };

    /**
     * Masks FICA numbers in dependent data if user doesn't have unmasked access
     * @param {Object} props - Component props containing user credentials and dependent data
     * @returns {Array} - Returns array of dependent data with masked or unmasked FICA numbers
     */
    const getMaskedDependentData = (props) => {
        if (!props.data) return [];

        const isUnmasked = checkIsUnmasked(props);

        return props.data.map(dependent => {
            if (isUnmasked) return dependent;

            const lastFour = dependent.fica_nbr.slice(-4);
            return {
                ...dependent,
                fica_nbr: `xxx-xx-${lastFour}`
            };
        });
    };



    const tableData = getMaskedDependentData(props).map((d) => {    return {
      ...d,
      VIEW: (
        <div
          className="editLink"
          onClick={() =>
            setState({
              ...state,
              open: true,
              dependent: d.seq_nbr,
              title: `${d.first_name} ${d.last_name}`,
            })
          }
        >
          view
        </div>
      ),
    };
  });

  const dependentsBenefitTableData = props.dependentBenefitsData
    .filter((plan) => plan.DEPENDENT === state.dependent)
    .sort((a, b) => new Date(b.START_DATE) - new Date(a.START_DATE))
    .map((plan) => plan);
  return (
    <div>
      <DialogTable
        isOpen={!!state.open}
        tableTitle={state.title}
        handleClose={handleClose}
        tableData={dependentsBenefitTableData}
        cols={dependentBenefitCols}
        fileName={`${props.fileName}_${state.title.replaceAll(' ', '_')}`}
      />
      <ReactTable cols={dependentCols} data={tableData} />
    </div>
  );
}
